import React from 'react';

import { WebPlayerActionsContextType } from './types';

export const WebPlayerActionContext = React.createContext<WebPlayerActionsContextType>(
  {} as WebPlayerActionsContextType
);
